import merceButtons from './tab-buttons/merce' 
import atletiButtons from './tab-buttons/atleti'
import corsiButtons from './tab-buttons/corsi'
import iscrittiButtons from './tab-buttons/iscritti'
import pagaButtons from './tab-buttons/pagamenti'
import misterButtons from './tab-buttons/mister'
import torneiButtons from './tab-buttons/tornei'
import venditeButtons from './tab-buttons/vendite'

const isAdmin = localStorage.getItem('usera') ? (JSON.parse(atob(localStorage.getItem('usera'))).isAdmin == 1) : false

// 1. Definisci l'array di base con il flag 'adminOnly' per i tab da filtrare.
const baseTabs = [
  {
    label: 'ATLETI',
    icon: 'pi pi-user',
    component: 'AtletiDataTable',
    name: 'AtletiDataTable',
    default: true,
    buttons: atletiButtons
  },
  {
    label: 'CORSI',
    icon: 'pi pi-copy',
    component: 'CorsiDataTable',
    name: 'CorsiDataTable',
    default: true,
    buttons: corsiButtons
  },  

  {
    label: 'STAFF',
    icon: 'fas fa-lightbulb',
    component: 'StaffDataTable',
    name: 'StaffDataTable',
    default: true,
    buttons: misterButtons,
    adminOnly: true // Tab visibile solo agli admin
  },
  {
    label: 'PRODOTTI',
    icon: 'pi pi-user',
    component: 'MerceDataTable',
    name: 'MerceDataTable',
    default: true,
    buttons: merceButtons,
    adminOnly: true // Tab visibile solo agli admin
  },
  {
    label: 'KIT',
    icon: 'pi pi-user',
    component: 'KitDataTable',
    name: 'KitDataTable',
    default: true,
    buttons: merceButtons,
    adminOnly: true // Tab visibile solo agli admin
  },
  {
    label: 'Tornei',
    icon: 'pi pi-users',
    component: 'TorneiDataTable',
    name: 'TorneiDataTable',
    default: true,
    buttons: torneiButtons,
    adminOnly: true // Tab visibile solo agli admin
  },
  
  
];

// 2. Filtra l'array in base allo stato di isAdmin.
const finalTabs = baseTabs.filter(tab => {
    // Mostra il tab se NON ha la proprietà adminOnly O se l'utente è admin.
    return !tab.adminOnly || isAdmin;
});

// 3. Esporta l'array filtrato.
export default finalTabs;